import React, { useState } from 'react';
import { TextField } from '@mui/material';
import DrawerShell from './DrawerShell';
import { FieldGroup } from '../PanelComerciales.styles';
import { Commercial } from '../PanelComerciales.types';
import { isEmail } from '../utils/validators';
import { VALIDITY_PERMANENT, validityOptionToDate } from '../utils/vipValidity';
import { OwnerSelectField, ValiditySelectField } from './VipFields';
import VipDrawerActions from './VipDrawerActions';

export interface VipAssignInput {
    clientEmail: string;
    sellerId: number;
    validity?: string;
}

interface AssignVipDrawerProps {
    open: boolean;
    onClose: () => void;
    commercials: Commercial[];
    existingEmails: string[];
    onSave: (vip: VipAssignInput) => void;
}

const AssignVipDrawer: React.FC<AssignVipDrawerProps> = ({
    open,
    onClose,
    commercials,
    existingEmails,
    onSave,
}) => {
    const [email, setEmail] = useState('');
    const [ownerId, setOwnerId] = useState<number | ''>('');
    const [validity, setValidity] = useState<string>(VALIDITY_PERMANENT);
    const [error, setError] = useState<string | null>(null);

    const close = () => {
        setEmail('');
        setOwnerId('');
        setValidity(VALIDITY_PERMANENT);
        setError(null);
        onClose();
    };

    const submit = () => {
        if (!isEmail(email)) return setError('Correo inválido');
        if (existingEmails.some((e) => e.toLowerCase() === email.trim().toLowerCase())) {
            return setError('Ya existe un VIP con ese correo');
        }
        if (!ownerId) return setError('Selecciona un comercial');

        onSave({
            clientEmail: email.trim().toLowerCase(),
            sellerId: ownerId,
            validity: validityOptionToDate(validity),
        });
        close();
    };

    return (
        <DrawerShell
            open={open}
            title='Asignar cuenta VIP'
            description='Busca al cliente por su correo. El resto de sus datos los resuelve el sistema.'
            onClose={close}
        >
            <FieldGroup>
                <label>Correo del cliente</label>
                <TextField
                    size='small'
                    type='email'
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder='correo@empresa.com'
                />
            </FieldGroup>
            <OwnerSelectField
                value={ownerId}
                commercials={commercials}
                onChange={setOwnerId}
            />
            <ValiditySelectField value={validity} onChange={setValidity} />
            <VipDrawerActions
                error={error}
                submitLabel='Asignar'
                onCancel={close}
                onSubmit={submit}
            />
        </DrawerShell>
    );
};

export default AssignVipDrawer;
